import React, { FC } from 'react';
import { Flex, FlexProps, useTheme } from '@chakra-ui/react';
import styled from '@emotion/styled/macro';
import { mq } from 'styles/breakpoints';

interface Props {
  image: string;
  gradient: string;
  offset?: string;
  slideHeight?: string;
  slideMinHeight?: string;
  maxSlideWidth?: boolean;
  bigger?: boolean;
}

const Wrapper = styled(Flex)<{
  image: string;
  slideHeight: string;
  slideMinHeight: string;
  offset: string;
  maxSlideWidth?: boolean;
  bigger?: boolean;
}>`
  width: 100%;
  max-width: ${(props): string => (props.maxSlideWidth ? '100%' : props.bigger ? '258px' : '237px')};
  min-width: 170px;
  height: ${(props): string => (props.slideHeight ? props.slideHeight : '488px')};
  min-height: ${(props): string => (props.slideMinHeight ? props.slideMinHeight : 'auto')};
  background-image: url(${(props): string => (props.image ? `${props.image}?q=30&auto=format` : '')});
  background-size: cover;
  border-radius: 14px;
  margin: ${(props): string => (props.offset ? props.offset : '0')};
  overflow: hidden;
`;

const GradientBox = styled(Flex)`
  height: 100%;
  width: 100%;
  flex-direction: column;
  padding: 30px 25px 25px 25px;
  position: relative;
  border-radius: 14px;
  overflow: hidden;

  ${mq.md} {
    padding: 24px 20px 25px 20px;
  }
`;

const GoalSlide: FC<Props & FlexProps> = ({ image, offset, slideHeight, slideMinHeight, gradient, maxSlideWidth, bigger, children }, props) => {
  const { colors } = useTheme();
  return (
    <Wrapper
      image={image}
      offset={offset}
      slideHeight={slideHeight}
      slideMinHeight={slideMinHeight}
      maxSlideWidth={maxSlideWidth}
      bigger={bigger}
      {...props}
    >
      <GradientBox bg={`linear-gradient(180deg, rgba(74, 95, 63, 0) 0%, ${gradient ? gradient : colors.white} 90.18%)`}>{children}</GradientBox>
    </Wrapper>
  );
};

export default GoalSlide;
